import dayjs from 'dayjs';

export const returnMepcoWorkSalaryRows = (
  row,
  reportBasicData,
  isProjectHourRowsEnabled,
  isRecordBasedReductions,
  paidCoffeeBreakMinutes,
  isAutomaticMealBreakReductionsAppliedToRecordBasedReductions,
  isMepcoLitteraEnabled
) => {
  const {
    userId,
    salaryType,
    unitCount,
    name,
    personNumber,
    eachDayTotalHours,
    rowComment,
  } = row;

  const userSalaryRows = [];

  const effectiveEachDayTotalHours = eachDayTotalHours || [];

  if (!isProjectHourRowsEnabled) {
    userSalaryRows.push({
      userId,
      salaryType,
      unitCount,
      projectName: '',
      assignmentName: '',
      earningPeriodStartDate: reportBasicData.fromDate,
      earningPeriodEndDate: reportBasicData.toDate,
      date: dayjs(reportBasicData.toDate).format('DD.MM.YYYY'),
      comment: rowComment,
      personName: name,
      personNumber,
    });
  } else {
    if (salaryType === 'WORK_SALARY_MONTHLY') {
      userSalaryRows.push({
        userId,
        salaryType,
        unitCount: 1,
        date: eachDayTotalHours
          ? eachDayTotalHours[0]?.day
          : reportBasicData.toDate,
        comment: rowComment,
        personName: name,
        personNumber,
      });
    } else {
      effectiveEachDayTotalHours.forEach((dayTotals) => {
        const { day, eachProjectHours } = dayTotals;
        let remainingPaidCoffeeBreakMinutes = paidCoffeeBreakMinutes;

        Object.values(eachProjectHours).forEach((projectHourData) => {
          const { hours, talosoftaProjectId, reductions, projectName } =
            projectHourData;

          let hoursWithReduction;

          if (isRecordBasedReductions) {
            let totalReducedBreakHours = 0;

            totalReducedBreakHours += reductions.BREAK;

            if (
              reductions.BREAK_MEAL === 0 &&
              isAutomaticMealBreakReductionsAppliedToRecordBasedReductions
            ) {
              totalReducedBreakHours +=
                reductions.AUTOMATIC_MEAL_BREAK_REDUCTION;
            } else {
              totalReducedBreakHours += reductions.BREAK_MEAL;
            }

            if (reductions.BREAK_COFFEE > 0) {
              // Convert coffee break from hours to minutes
              const coffeeBreakMinutes = reductions.BREAK_COFFEE * 60;
              // Calculate how much coffee break time to reduce from work hours
              const coffeeBreakReduction =
                Math.max(
                  0,
                  coffeeBreakMinutes - remainingPaidCoffeeBreakMinutes
                ) / 60;
              totalReducedBreakHours += coffeeBreakReduction;
              remainingPaidCoffeeBreakMinutes = Math.max(
                0,
                remainingPaidCoffeeBreakMinutes - coffeeBreakMinutes
              );
            }

            hoursWithReduction = hours - totalReducedBreakHours;
          } else {
            hoursWithReduction =
              reductions.AUTOMATIC_MEAL_BREAK_REDUCTION &&
              reductions.AUTOMATIC_MEAL_BREAK_REDUCTION > 0
                ? hours - reductions.AUTOMATIC_MEAL_BREAK_REDUCTION
                : hours;
          }

          // Littera: split the project-day's reduced hours across its
          // assignments proportionally to raw worked hours, emitting one row per
          // assignment with the littera (assignment number + name). The split
          // values always sum back to hoursWithReduction.
          const litteraAssignmentBuckets =
            isMepcoLitteraEnabled && projectHourData.assignmentHours
              ? Object.values(projectHourData.assignmentHours)
              : [];

          const totalRawAssignmentHours = litteraAssignmentBuckets.reduce(
            (sum, assignmentBucket) => sum + assignmentBucket.hours,
            0
          );

          if (
            litteraAssignmentBuckets.length > 0 &&
            totalRawAssignmentHours > 0
          ) {
            litteraAssignmentBuckets.forEach((assignmentBucket) => {
              const proportion =
                assignmentBucket.hours / totalRawAssignmentHours;

              userSalaryRows.push({
                talosoftaProjectId,
                projectName,
                userId,
                salaryType,
                unitCount: hoursWithReduction * proportion,
                littera: assignmentBucket.assignmentNumber || '',
                date: dayjs(day).format('DD.MM.YYYY'),
                personName: name,
                personNumber,
              });
            });
          } else {
            userSalaryRows.push({
              talosoftaProjectId,
              projectName,
              userId,
              salaryType,
              unitCount: hoursWithReduction,
              date: dayjs(day).format('DD.MM.YYYY'),
              personName: name,
              personNumber,
            });
          }
        });
      });
    }
  }

  return userSalaryRows;
};
